// extracted by mini-css-extract-plugin
module.exports = {"category_breadrcrumb":"categoryBannerRegular_category_breadrcrumb__LxDnl","category_banner":"categoryBannerRegular_category_banner__Nm2A_"};